const SnackbarMessages = {
    PASSWORD_EXPIRED_MESSAGE:
        'Your password has expired as part of our security policy to rotate passwords. Please reset your password below to access the portal.',
    PASSWORD_UPCOMING_EXPIRY_MESSAGE: (expiryDay) =>
        `As per updated security measures, your password will expire in the next ${expiryDay} days. Please update it.`
};

export { SnackbarMessages };
